// extracted by mini-css-extract-plugin
export default {"tadaDetails":"gift-tracker-modal-styles__tadaDetails__hUNyS"};